import { render, staticRenderFns } from "./SensorMonitor.vue?vue&type=template&id=7008ea3b&"
import script from "./SensorMonitor.vue?vue&type=script&lang=js&"
export * from "./SensorMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports